import { renderLocationSidebar } from './locationSidebar';

export const DICTIONARIES_TEMPLATE = `
<div class="flex min-h-screen overflow-hidden">
${renderLocationSidebar('dictionaries')}
<main class="ml-64 flex-1 flex flex-col min-w-0 min-h-0 bg-background-light">
<header class="h-20 bg-white border-b border-slate-200 flex items-center justify-between px-8 shrink-0">
<div>
<h2 class="text-2xl font-bold tracking-tight">Dictionaries</h2>
<p class="text-sm text-slate-500">Manage reference data for all modules</p>
</div>
<div class="flex items-center gap-4">
<div class="relative">
<span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xl">search</span>
<input id="dictionaries-search-input" class="pl-10 pr-4 py-2 bg-slate-100 border-none rounded-lg text-sm w-64 focus:ring-2 focus:ring-primary/50 transition-all" placeholder="Search by name or slug..." type="text"/>
</div>
<a id="dictionaries-add-entry-btn" class="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 transition-all shadow-lg shadow-primary/20" href="/dictionaries/create">
<span class="material-symbols-outlined text-lg">add_circle</span>
Add Dictionary Entry
</a>
</div>
</header>
<div class="px-8 pt-4 bg-white border-b border-slate-200">
<div class="flex gap-8">
<button class="pb-3 border-b-2 border-primary text-primary font-semibold text-sm flex items-center gap-2 px-1" data-module="locations" type="button">
<span class="material-symbols-outlined text-lg">location_on</span> Locations
</button>
<button class="pb-3 border-b-2 border-transparent text-slate-500 hover:text-slate-700 font-medium text-sm flex items-center gap-2 px-1 transition-colors" data-module="routes" type="button">
<span class="material-symbols-outlined text-lg">route</span> Routes
</button>
<button class="pb-3 border-b-2 border-transparent text-slate-500 hover:text-slate-700 font-medium text-sm flex items-center gap-2 px-1 transition-colors" data-module="news" type="button">
<span class="material-symbols-outlined text-lg">article</span> News
</button>
<button class="pb-3 border-b-2 border-transparent text-slate-500 hover:text-slate-700 font-medium text-sm flex items-center gap-2 px-1 transition-colors" data-module="events" type="button">
<span class="material-symbols-outlined text-lg">event</span> Events
</button>
</div>
</div>
<div class="flex-1 min-h-0 flex overflow-hidden p-6 gap-6">
<aside class="w-64 min-h-0 flex flex-col shrink-0 bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
<div class="p-4 bg-slate-50 border-b border-slate-200">
<h3 id="dictionaries-groups-title" class="text-xs font-bold text-slate-400 uppercase tracking-widest">Location Groups</h3>
</div>
<div id="dictionaries-groups" class="flex-1 overflow-y-auto p-2 space-y-1">
<p class="px-3 py-2 text-sm text-slate-500">Loading groups...</p>
</div>
</aside>
<div class="flex-1 min-h-0 bg-white rounded-xl border border-slate-200 overflow-hidden flex flex-col shadow-sm">
<div class="p-4 border-b border-slate-200 flex flex-wrap items-center justify-between gap-4">
<div class="flex items-center gap-2">
<select id="dictionaries-status-filter" class="text-sm bg-slate-100 border-none rounded-lg focus:ring-primary py-1.5 px-3">
<option value="all">Status: All</option>
<option value="active">Active</option>
<option value="inactive">Inactive</option>
</select>
<select id="dictionaries-sort-filter" class="text-sm bg-slate-100 border-none rounded-lg focus:ring-primary py-1.5 px-3">
<option value="sort_order_asc">Sort by: Sort Order</option>
<option value="name_asc">Sort by: Name (A-Z)</option>
<option value="name_desc">Sort by: Name (Z-A)</option>
<option value="updated_desc">Sort by: Recently Updated</option>
<option value="slug_asc">Sort by: Slug</option>
</select>
</div>
<div class="flex items-center gap-2">
<span class="text-xs font-semibold text-slate-400 mr-2">Bulk actions:</span>
<button id="dictionaries-bulk-activate" class="text-xs bg-emerald-500/10 text-emerald-600 px-3 py-1.5 rounded-lg font-bold hover:bg-emerald-500/20 transition-colors">Activate</button>
<button id="dictionaries-bulk-deactivate" class="text-xs bg-rose-500/10 text-rose-600 px-3 py-1.5 rounded-lg font-bold hover:bg-rose-500/20 transition-colors">Deactivate</button>
<button id="dictionaries-bulk-delete" class="text-xs bg-rose-600 text-white px-3 py-1.5 rounded-lg font-bold hover:bg-rose-700 transition-colors">Delete</button>
</div>
</div>
<div class="flex-1 min-h-0 overflow-auto">
<table class="w-full text-left border-collapse">
<thead class="sticky top-0 bg-slate-50 z-10">
<tr>
<th class="p-4 w-10"><input id="dictionaries-select-all" class="rounded border-slate-300 text-primary focus:ring-primary" type="checkbox"/></th>
<th class="p-4 text-xs font-bold text-slate-500 uppercase">Name</th>
<th class="p-4 text-xs font-bold text-slate-500 uppercase">Slug/Code</th>
<th class="p-4 text-xs font-bold text-slate-500 uppercase">Module</th>
<th class="p-4 text-xs font-bold text-slate-500 uppercase">Status</th>
<th class="p-4 text-xs font-bold text-slate-500 uppercase text-center">Sort Order</th>
<th class="p-4 text-xs font-bold text-slate-500 uppercase">Updated At</th>
<th class="p-4 text-xs font-bold text-slate-500 uppercase text-right">Actions</th>
</tr>
</thead>
<tbody id="dictionaries-table-body" class="divide-y divide-slate-200">
<tr>
<td class="p-6 text-sm text-slate-500" colspan="8">Loading dictionaries...</td>
</tr>
</tbody>
</table>
</div>
<div class="p-4 border-t border-slate-200 flex items-center justify-between gap-4">
<p id="dictionaries-table-meta" class="text-xs text-slate-500 font-medium">Showing 0 entries</p>
<div class="flex items-center gap-2">
<button id="dictionaries-prev-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Prev</button>
<span id="dictionaries-page-indicator" class="text-xs font-semibold text-slate-500 min-w-[72px] text-center">Page 1</span>
<button id="dictionaries-next-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Next</button>
</div>
</div>
</div>
</div>
</main>
</div>
<div id="dictionaries-modal" class="fixed inset-0 z-[70] hidden">
<div id="dictionaries-modal-backdrop" class="absolute inset-0 bg-slate-900/40"></div>
<div class="absolute inset-0 flex items-center justify-center p-4">
<div class="w-full max-w-md rounded-2xl border border-slate-200 bg-white shadow-2xl">
<div class="px-6 pt-6">
<h3 id="dictionaries-modal-title" class="text-lg font-bold text-slate-900">Confirm Action</h3>
<p id="dictionaries-modal-message" class="mt-2 text-sm text-slate-600">Are you sure?</p>
</div>
<div class="mt-6 flex items-center justify-end gap-3 px-6 pb-6">
<button id="dictionaries-modal-cancel" class="px-4 py-2 rounded-lg border border-slate-200 text-slate-700 font-semibold hover:bg-slate-50" type="button">Cancel</button>
<button id="dictionaries-modal-confirm" class="px-4 py-2 rounded-lg bg-primary text-white font-semibold hover:bg-primary/90" type="button">Confirm</button>
</div>
</div>
</div>
</div>
<div id="dictionaries-toast" class="fixed right-6 top-6 z-[80] hidden min-w-[260px] max-w-sm rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-medium text-rose-700 shadow-lg"></div>
`;
